// extracted by mini-css-extract-plugin
export var active = "ComponentUspCarousel-module--active--f93d6";
export var carouselPageIndicator = "ComponentUspCarousel-module--carouselPageIndicator--b8c59";
export var carouselPagination = "ComponentUspCarousel-module--carouselPagination--0e8ff";
export var carouselSlide = "ComponentUspCarousel-module--carouselSlide--5dfdb";
export var carouselSlider = "ComponentUspCarousel-module--carouselSlider--24348";
export var description = "ComponentUspCarousel-module--description--7748c";
export var desktopContent = "ComponentUspCarousel-module--desktopContent--6f867";
export var fill = "ComponentUspCarousel-module--fill--860d3";
export var heading = "ComponentUspCarousel-module--heading--7e1c0";
export var image = "ComponentUspCarousel-module--image--5f486";
export var item = "ComponentUspCarousel-module--item--75b37";
export var itemContainer = "ComponentUspCarousel-module--itemContainer--84e11";
export var lottie = "ComponentUspCarousel-module--lottie--8b2e6";
export var media = "ComponentUspCarousel-module--media--d9ede";
export var mediaContainer = "ComponentUspCarousel-module--mediaContainer--5bd73";
export var mediaWrapper = "ComponentUspCarousel-module--mediaWrapper--f855e";
export var mobileContent = "ComponentUspCarousel-module--mobileContent--d7514";
export var progressBar = "ComponentUspCarousel-module--progressBar--da757";
export var section = "ComponentUspCarousel-module--section--7ce0e";